import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'flow-tabs-route',
  templateUrl: './tabs-route.component.html',
  styleUrls: ['./tabs-route.component.scss'],
})
export class TabsRouteComponent {
  @Input() activeTab: number = 0;
  @Input() tabs: {
    id?: number;
    title: string;
    subtitle?: string;
    path: string;
    disabled?: boolean;
  }[] = [];
  @Output() activeTabChange = new EventEmitter<number>();

  onTabClick(index: number) {
    if (this.tabs[index]?.disabled) {
      return;
    }
    this.activeTab = index;
    this.activeTabChange.emit(index);
  }
}
